import { IEstimator } from '@abrController/Estimators/IEstimator';
import { IMinimalBufferToIncreaseEstimatorConfig } from '@abrController/Estimators/MinimalBufferToIncreaseEstimator/MinimalBufferToIncreaseEstimator.config';
import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { EDebuggableModuleState, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import { IResolution } from '@resolutionsManager/IResolutionsManager';

export class MinimalBufferToIncreaseEstimator extends ConfigConsumer<IMinimalBufferToIncreaseEstimatorConfig> implements IEstimator {
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public additionalInfo: TDebuggableAdditionalInfo = {};
  public groups: string[] = ['abr'];

  constructor(eventBus: TEventBus) {
    super('minimalBufferToIncreaseEstimator', eventBus);
  }

  public destroy(): void {
    super.destroy();
  }

  public reset(): void {}

  public getNextEstimatedResolution(
    availableDecreasingResolutions: IResolution[],
    currentResolution: IResolution | null,
    metrics: IBufferMetrics,
  ): IResolution | null {
    return metrics.bufferAmount * 1000 > this.config.minimalBufferAmount ? null : currentResolution;
  }

  public _handleConfigUpdated(): void {}
}
